import { useQuery } from "@tanstack/react-query";
import { Opportunity } from "./useOpportunitiesApi";

export interface OpportunityResponse {
  data: Opportunity;
  message: string;
}

export function useOpportunityApi(id: string) {
  return useQuery({
    queryKey: ["opportunity", id],
    queryFn: async () => {
      const params = new URLSearchParams();
      params.append('id', id);
      
      const response = await fetch(`${import.meta.env.VITE_CC_API_URL}/v1/opportunities/?${params.toString()}`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      
      // The API returns an array with a single opportunity, so we need to extract it
      if (responseData.data && responseData.data.length > 0) {
        return {
          data: responseData.data[0],
          message: responseData.message || "Success"
        } as OpportunityResponse;
      }
      
      throw new Error("Opportunity not found");
    },
    enabled: !!id,
  });
}

export function useSimilarOpportunities(id: string, focusArea: string, limit: number = 3) {
  return useQuery({
    queryKey: ["similar-opportunities", id, focusArea],
    queryFn: async () => {
      const params = new URLSearchParams();
      params.append('limit', limit.toString());
      params.append('focus_area', focusArea);
      params.append('exclude', id);

      const response = await fetch(`${import.meta.env.VITE_CC_API_URL}/v1/opportunities/?${params.toString()}`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    },
    enabled: !!id && !!focusArea,
  });
}
